/**
 * Checks if a subscription expires within the specified number of days
 * @param expiryTime - The subscription expiry time (Date object or undefined)
 * @param days - Number of days to check (default: 14)
 * @returns true if subscription expires within the specified days, false otherwise
 */
export function isSubscriptionExpiringWithinDays(
  expiryTime: Date | undefined,
  days: number = 14,
): boolean {
  if (!expiryTime) {
    return false
  }

  const now = new Date()
  const expiryDate = new Date(expiryTime)
  const daysUntilExpiry = Math.ceil(
    (expiryDate.getTime() - now.getTime()) / (1000 * 60 * 60 * 24),
  )

  return daysUntilExpiry > 0 && daysUntilExpiry <= days
}
